import { render, staticRenderFns } from "./DiseaseCallLogs.vue?vue&type=template&id=9945c0f8&scoped=true"
import script from "./DiseaseCallLogs.vue?vue&type=script&lang=js"
export * from "./DiseaseCallLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9945c0f8",
  null
  
)

export default component.exports